import { CampaignStatusSchema as i, AdGroupIdSchema as b, CampaignIdSchema as r, SingleDimensionInputSchema as T, SingleDimensionOutputSchema as F, CampaignDealTypeSchema as _, PercentSchema as S, CpaAutoRuleIdSchema as M, UserIdSchema as H, CreativeGroupIdSchema as u, TargetGroupIdSchema as f, DateTimeSchema as m, OnOffSchema as U, CampaignGroupIdSchema as k, TrafficLimitSchema as R, BudgetLimitInputSchema as I, BidSchema as V, PricingRuleModelSchema as N, DeliverySchema as q, isInputDimension as z, SingleStartStopDimensionInputSchema as W, StoredBudgetLimitSchema as D } from "@hprofits/shared";
import { CpaAutoRulesExclusionsSchema as X } from "@hprofits/shared/dimensions";
import { optional as v } from "@hprofits/utils/fp/optional";
import { z as t } from "zod";
import { API_VIEW as A } from "../common/acl-view.js";
import "@hprofits/utils";
import "@orpc/contract";
import "@orpc/openapi";
import "../swagger/security.js";
import "../swagger/tags.js";
import "../common/owner.js";
import "../common/params.js";
const $ = t.partialRecord(
  i.exclude([i.enum.Hidden]),
  t.number().int().nonnegative()
), J = t.object({
  id: b,
  name: t.string(),
  detailedStatus: $
}).readonly(), Pe = t.array(J).readonly(), C = (e) => t.object({
  id: e,
  name: t.string().trim().min(1, "name must be non-empty").max(30),
  selected: t.boolean()
}).readonly(), Ae = C(f), Ce = C(u), L = t.enum(["calculated", "shared"]), K = t.enum(["manual", "auto"]), o = (e) => t.object({
  modifier: K,
  value: e
}).readonly(), l = (e, n) => !!(e && n && e.value > n.value), d = t.object({
  delivery: o(q),
  pricingModel: o(N),
  bid: o(V),
  budgetLimitOverall: o(I).optional(),
  budgetLimitDaily: o(I).optional(),
  trafficLimitOverall: o(R).optional(),
  trafficLimitDaily: o(R).optional(),
  cappingImpressions: o(t.int().nonnegative()).optional(),
  cappingFrequency: o(t.int().nonnegative()).optional()
}), Le = t.object({
  forceDeleteIds: t.array(r).readonly().optional()
}), w = {
  budgetLimitOverall: o(D).optional(),
  budgetLimitDaily: o(D).optional()
}, P = 30, Q = d.partial().extend({
  id: r.optional(),
  parentId: r.optional(),
  dimension: T.optional()
}), h = (e) => z(e, W), O = (e, n) => {
  if (!e || e.length === 0)
    return;
  const s = e.filter((a) => a.dimension !== "other");
  if (s.length === 0)
    return;
  const c = s.some((a) => h(a.dimension)), g = s.some((a) => a.dimension && !h(a.dimension));
  c && g && n.addIssue("Sub-rules at one level must all be time-based or all be dimension-based");
}, G = t.strictObject({
  ...Q.shape,
  get subRules() {
    return t.array(G).optional();
  }
}).superRefine((e, n) => {
  if (e.dimension || n.addIssue("Sub-rule dimension is required"), l(e.budgetLimitDaily, e.budgetLimitOverall) && n.addIssue("Daily budget limit must be less than overall limit"), l(e.trafficLimitDaily, e.trafficLimitOverall) && n.addIssue("Daily traffic limit must be less than overall limit"), e.dimension && e.dimension !== "other" && !h(e.dimension)) {
    const s = e.dimension, c = [
      "domains",
      "spots",
      "geo",
      "languages",
      "browsers",
      "devices",
      "os",
      "ips",
      "keywords",
      "categories",
      "contentTypes"
    ];
    for (const g of c) {
      const a = s[g];
      if (a && typeof a == "object" && "type" in a && a.type === "exclude") {
        n.addIssue("Exclude dimensions are not allowed in sub-rules");
        break;
      }
    }
  }
  O(e.subRules, n);
}), Y = d.extend({
  ...w,
  id: r,
  parentId: r,
  status: i,
  statusChangeReason: t.string().optional(),
  dimension: F.optional(),
  /**
   * The target group blocks this sub-rule's dimension, so it can never buy.
   * Derived on read from the rule's target group — output only, never accepted
   * on input, and never persisted.
   */
  targetConflict: t.boolean()
}), y = Y.extend({
  get subRules() {
    return t.array(y).readonly().optional();
  }
}), j = (e) => d.extend({
  ...w,
  id: r,
  mode: L,
  targetGroupId: f,
  creativeGroupId: u,
  status: i,
  statusChangeReason: t.string().optional(),
  startDate: m.optional(),
  endDate: m.optional(),
  subRules: t.array(e)
}).readonly(), Z = 1e3, ee = 4, te = t.number().positive().max(Z).multipleOf(10 ** -ee), E = t.object({
  priority: _,
  resellFeePercent: S.optional(),
  directFeePercent: S.optional(),
  autoRotateIsEnabled: t.boolean(),
  feedUrl: t.url().optional(),
  // todo: support this feature ?
  cpaAutoRuleIds: t.array(M).refine((e) => new Set(e).size === e.length, { error: "cpaAutoRuleIds must not contain duplicate ids" }).readonly().optional(),
  trainingPercent: S.optional(),
  cpaCoef: te.optional()
}).readonly(), ne = E.unwrap().extend({
  ownerId: H,
  cpaAutoRulesExclusions: X.optional()
}).readonly(), x = d.extend({
  id: r.optional(),
  mode: L,
  targetGroupId: f,
  creativeGroupId: u,
  startDate: m.optional(),
  endDate: m.optional(),
  subRules: t.array(G)
}).strict(), ie = (e, n) => !!(e && n && n < e), ae = (e) => !!(e && new Date(e) < /* @__PURE__ */ new Date()), B = (e, n) => {
  const s = v(e.startDate), c = v(e.endDate);
  ie(s, c) && n.addIssue("End date must be after start date!"), ae(c) && n.addIssue("End date cannot be in the past!"), l(e.budgetLimitDaily, e.budgetLimitOverall) && n.addIssue("Daily budget limit must be less than overall limit"), l(e.trafficLimitDaily, e.trafficLimitOverall) && n.addIssue("Daily traffic limit must be less than overall limit"), O(e.subRules, n);
}, oe = x.superRefine(B).readonly(), se = x.extend(E.unwrap().shape).superRefine(B).readonly(), we = t.union([oe, se]), re = t.object({
  oldStatus: i,
  newStatus: i.exclude([
    i.enum.Hidden,
    i.enum.Active,
    i.enum.Rejected
  ])
}).strict().readonly(), ce = t.object({
  oldStatus: i,
  newStatus: i.exclude([
    i.enum.Hidden,
    i.enum.Active,
    i.enum.Rejected
  ]),
  reason: t.string().min(1).optional()
}).strict().readonly(), Oe = t.union([
  re,
  ce
]), me = j(y).unwrap().extend({
  view: t.literal(A.common)
}).readonly(), le = j(y).unwrap().extend({
  ...ne.unwrap().shape,
  view: t.literal(A.admin)
}).readonly(), ue = t.discriminatedUnion("view", [
  me,
  le
]), p = t.object({
  name: t.string().trim().min(1, "name must be non-empty").max(P, `name must be at most ${P} characters`),
  status: U
}).strict().readonly(), Ge = t.object({
  sourceId: b,
  name: p.unwrap().shape.name,
  creativeGroupId: u
}).strict().readonly(), je = p.unwrap().pick({ status: !0 }).strict().readonly(), Ee = t.object({
  name: p.unwrap().shape.name
}).strict().readonly(), xe = p.unwrap().extend({
  id: b,
  campaignId: k,
  pricingRules: t.array(ue).readonly()
}).readonly();
export {
  P as AD_GROUP_NAME_MAX_LENGTH,
  Pe as AdGroupListSchema,
  J as AdGroupListViewSchema,
  xe as AdGroupSchema,
  ee as CPA_COEF_DECIMAL_PLACES,
  Z as CPA_COEF_MAX,
  Ge as CopyAdGroupSchema,
  te as CpaCoefSchema,
  p as CreateAdGroupSchema,
  Ce as CreativeGroupReferenceSchema,
  K as LimitFieldModifierSchema,
  se as PricingRuleAdminInputSchema,
  le as PricingRuleAdminViewSchema,
  E as PricingRuleAdminWritableFieldsSchema,
  oe as PricingRuleCommonInputSchema,
  me as PricingRuleCommonViewSchema,
  Le as PricingRuleForcedDeletionsSchema,
  we as PricingRuleInputSchema,
  L as PricingRuleModeSchema,
  ne as PricingRuleOutputAdminFieldsSchema,
  ue as PricingRuleOutputSchema,
  $ as PricingRuleSetDetailedStatusSchema,
  d as PricingRuleSettingsSchema,
  ce as PricingRuleStatusChangeAdminSchema,
  re as PricingRuleStatusChangeCommonSchema,
  Oe as PricingRuleStatusChangeSchema,
  Ee as RenameAdGroupSchema,
  Q as SubTargetPricingRuleInputBaseSchema,
  G as SubTargetPricingRuleInputSchema,
  Y as SubTargetPricingRuleOutputBaseSchema,
  y as SubTargetPricingRuleOutputSchema,
  Ae as TargetGroupReferenceSchema,
  je as UpdateAdGroupSchema,
  C as createNamedReferenceSchema,
  l as hasDailyLimitAboveOverall
};
//# sourceMappingURL=schemas.js.map
